module.exports = (el) => {
    const btn = $(el);
    const checkBoxes = $(btn.data('selector'));
    let checkBoxesSelected = true;
    
    function init() {
        toggleClassIfSelected();
    }
    
    function onButtonClick() {
        if(checkBoxesSelected) {
            checkBoxes.prop('checked', false);
        } else {
            checkBoxes.prop('checked', true);
        }
        
        checkBoxes.change();
    }
    
    function onCheckboxesChange() {
        toggleClassIfSelected();
    }
    
    function isAnyCheckboxChecked() {
        let checked = false;
        
        checkBoxes.each((i, el) => {
            if ($(el).prop('checked')) {
                checked = true;
            }
        });

        return checked;
    }
    
    function toggleClassIfSelected() {
        if (isAnyCheckboxChecked()) {
            btn.addClass('selected');
            checkBoxesSelected = true;
        } else {
            btn.removeClass('selected');
            checkBoxesSelected = false;
        }
    }
    
    checkBoxes.on('change', onCheckboxesChange);
    btn.on('click', onButtonClick);
    
    init();
}